import { Handler } from '../../../patterns/chainOfResponsibility';
import { FilterStatisticsHandler } from '../../../patterns/chainOfResponsibility/FilterStatisticsHandler';
import { Data } from '../../../patterns/commands';
import { FilterTypes } from '../interfaces';
import { FilterStatistics, Statistic } from './statistics.worker';

export class StatisticsLaborer {
    private handlers: Handler[] = [];
    private results: FilterStatistics = {
        total: 0,
        statistics: [],
    };

    public constructor(filterTypes: FilterTypes[]) {
        this.buildHandlers(filterTypes);
    }

    private buildHandlers(filterTypes: FilterTypes[]): void {
        let previousHandler: Handler | null = null;

        // Create filter handlers
        filterTypes.forEach((filter) => {
            const handler = new FilterStatisticsHandler({ filterType: filter.type, keys: filter.keys });
            if (previousHandler) {
                previousHandler.setNext(handler);
            }
            previousHandler = handler;
            this.handlers.push(handler);
        });
    }

    public processData(data: Data): Data {
        if (this.handlers.length === 0) {
            this.results.total = (data as [])?.length || 0;
            return this.results;
        }

        const currentResult = this.handlers[0].handleRequest(data, []) as Statistic[];
        this.results.total = currentResult.reduce((p, c) => p + c.statistics.value, 0);
        this.results.statistics = [...this.results.statistics, currentResult].flat();

        return this.results;
    }
}
